import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { find } from 'lodash'
import { ItemData } from '../apis/item.api'
import contactSiteApi from '../apis/contactSite.api'
import itemService from '../services/item.service'
import { ActionName } from '../components/Actions'
import Heading from '../components/Heading'
import Row from '../components/Row/Row'
import Select, { SelectOption } from '../components/Select'
import TableHorizontal, {
  TableHorizontalData, TableHorizontalHeader
} from '../components/TableHorizontal'
import Button from '../components/Button'
import InputText from '../components/InputText'

export interface PurchaseOrderItemInputItem {
  id: number
  code: string
  description: string
  quantity: string
}

interface PurchaseOrderItemInputSelected
  extends PurchaseOrderItemInputItem, TableHorizontalData {}

interface PurchaseOrderItemInputProps {
  vendorSiteId: number
  selecteds: PurchaseOrderItemInputSelected[]
  onAdd: (item: PurchaseOrderItemInputItem) => void
  oneDelete: (id: number) => void
}

interface PurchaseOrderItemInputState {
  itemId: string
  quantity: string
  items: ItemData[]
}

export default class PurchaseOrderItemInput
  extends Component<PurchaseOrderItemInputProps, PurchaseOrderItemInputState> {
  headers: TableHorizontalHeader[] = [
    { heading: i18n("Item"), path: 'code' },
    { heading: i18n("Description"), path: 'description' },
    { heading: i18n("Line quantity"), path: 'quantity' },
    { heading: i18n("Actions") }
  ]

  constructor (props: PurchaseOrderItemInputProps) {
    super(props)
    this.state = {
      itemId: '',
      quantity: '',
      items: []
    }
    this.handleItemSelect = this.handleItemSelect.bind(this)
    this.handleAdd = this.handleAdd.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleActionsClick = this.handleActionsClick.bind(this)
  }

  get itemSelectOptions (): SelectOption[] {
    return itemService.selectOptions(this.state.items)
  }

  get quantityInput () {
    return this.state.itemId &&
      <InputText
        name="quantity"
        value={this.state.quantity}
        label={i18n("Quantity")}
        onChange={this.handleInputChange} />
  }

  listItems () {
    const { vendorSiteId } = this.props
    contactSiteApi.listItems(vendorSiteId, items => {
      if (!items) return
      this.setState({ items })
    })
  }

  resetFields () {
    this.setState({ itemId: '', quantity: '' })
  }

  handleItemSelect (name: string, itemId: string) {
    const { items } = this.state
    const item = itemService.find(items, Number(itemId))
    if (!item) return
    const quantity = String(item.cpp)
    this.setState({ itemId, quantity })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'quantity') this.setState({ quantity: value })
  }

  handleAdd () {
    const { itemId, items, quantity } = this.state
    if (!itemId) return
    const item = find(items, { id: Number(itemId) })
    if (!item || !quantity) return
    const selected: PurchaseOrderItemInputSelected = {
      id: Number(item.id),
      code: item.code,
      description: item.description,
      quantity,
      actions: ['delete']
    }
    this.props.onAdd(selected)
    this.resetFields()
  }

  handleActionsClick (id: number, action: ActionName) {
    if (action === 'delete') this.props.oneDelete(id)
  }

  componentDidMount () {
    this.listItems()
  }

  render () {
    return (
      <div>
        <Heading text={i18n("Items")} />
        <div className="mt-2">
          <TableHorizontal
            headers={this.headers}
            data={this.props.selecteds}
            onActionClick={this.handleActionsClick} />
          <Row column={3}>
            <Select
              name="item"
              value={this.state.itemId}
              options={this.itemSelectOptions}
              label={i18n("Item")}
              onChange={this.handleItemSelect} />
            {this.quantityInput}
            <div className="flex items-end mb-4">
              <Button
                text={i18n("Add item")}
                full={true}
                onClick={this.handleAdd} />
            </div>
          </Row>
        </div>
      </div>
    )
  }
}
